import { UPDATE_BOTH } from '../../hdrm/constants/update-strategies';

const DEFAULT_OPTIONS = {
  strategy: UPDATE_BOTH,
};

export default DEFAULT_OPTIONS;
